import { INVALIDATE_DETTES, INVALIDATE_DETTES_CLIENT } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import {
  GET_ALL_DETTES_API_ROUTE,
  GET_ALL_DETTES_BY_USER_API_ROUTE
} from "routes/api/endpoints";

const dettesApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getAllDettes: build.query({
      query: ({ dossier_id }) => `${GET_ALL_DETTES_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
      providesTags: [INVALIDATE_DETTES],
    }),
    getAllDettesByUser: build.query({
      query: ({ client_id }) => `${GET_ALL_DETTES_BY_USER_API_ROUTE}?client_id=${client_id}`,
      providesTags: [INVALIDATE_DETTES_CLIENT],
    }),
    getDetteById: build.query({
      query: ({ id, dossier_id }) => `${GET_ALL_DETTES_API_ROUTE}${id}/?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_DETTES],
    }),
  }),
});

export const {
  useGetAllDettesQuery,
  useGetAllDettesByUserQuery,
  useGetDetteByIdQuery
} = dettesApi;
